/** @format */

import React from 'react';
import { useStyles } from './style';
import { Card, AppBar, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import ListDetailAccounts from './ListDetailAccounts';
import { CreateDetailAccounts } from './CreateDetailAccounts';
import useCustomHook from './hooks';

export function DetailAccounts() {
    const classes = useStyles();
    const { valueTab, setValueTab } = useCustomHook();
    const handleChangeTab = (event, newValue) => {
        setValueTab(newValue);
    };

    return (
        <div className={classes.root}>
            <Card>
                <TabContext value={valueTab}>
                    <AppBar position="static">
                        <TabList onChange={handleChangeTab}>
                            <Tab label="لیست حساب ها" value="list" />
                            <Tab label="ایجاد حساب" value="creat" />
                        </TabList>
                    </AppBar>
                    <TabPanel value={valueTab == 'list' && 'list'}>
                        <ListDetailAccounts setValueTab={setValueTab} handleChangeTab={handleChangeTab} />
                    </TabPanel>
                    <TabPanel value={valueTab == 'creat' && 'creat'}>
                        <CreateDetailAccounts setValueTab={setValueTab} handleChangeTab={handleChangeTab} />
                    </TabPanel>
                </TabContext>
            </Card>
        </div>
    );
};

